import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'

// state
export const state = {
  items: [],
  total: 0,
  pdf: undefined
}

// getters
export const getters = {
  filtersData: state => state.filtersData,
  items: state => state.items,
  total: state => state.total,
  pdf: state => state.pdf
}

// mutations
export const mutations = {

  ITEMS_DATA (state, data) {
    state.items = data
  },

  TOTAL (state, data) {
    state.total = data
  },

  PDF (state, data) {
    state.pdf = data
  }
}

// actions
export const actions = {

  async fetchAll ({ commit }, filterData) {
    const { data } = await axios.get(laroute.route('inventory_status', { companyAbbr: store.getters['auth/company'], ...filterData }))
    commit('ITEMS_DATA', data.items)
    commit('TOTAL', data.total)
  },

  async generatePDF ({ commit }, { filterData }) {
    const { data } = await axios.get(laroute.route('inventory_status_pdf', { companyAbbr: store.getters['auth/company'], ...filterData }), { responseType: 'arraybuffer' })
    commit('PDF', data)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/inventoryStatus.js